<template>
	<div class="widget widget-kpi" :class="{ 'fullscreen-widget': isFullscreen, [params.shape]: params.shape }" ref="widgetRootRef">
		<v-card class="mx-auto" flat>
			<template v-if="!isLoading">
				<v-toolbar color="transparent" @click="toggleFullscreen" v-if="isFullscreen">
					<div class="v-card-top-actions">
						<span>
							<md-icon>chevron_left</md-icon>
							{{ t('Back') }}
						</span>
					</div>
					<v-toolbar-title>
						{{ title }}
					</v-toolbar-title>
					<div class="v-card-top-actions">
						<md-icon v-if="!isFullscreen">arrow_circle_right</md-icon>
					</div>
				</v-toolbar>

				<v-card-text>
					<Kpi v-show="!isFullscreen" :title="title" :color="kpi.color" :width="kpi.width" :params="params" :guid="guid" :show-difference="false" @click="toggleFullscreen" />
					<KpiBuilder v-if="isFullscreen" :title="title" :color="kpi.color" :width="kpi.width" :params="params" :guid="guid" />
				</v-card-text>
			</template>

			<template v-else>
				<v-progress-circular indeterminate :color="kpi.color" :width="kpi.width"></v-progress-circular>
			</template>
		</v-card>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, inject, nextTick } from 'vue';
import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { useTranslator } from '@/utils/useTranslator';
import { eventBus } from '@/utils/eventBus';
import Kpi from '@/components/kpi/Kpi.vue';
import KpiBuilder from '@/components/kpi/KpiBuilder.vue';

// #region DATA

const t = useTranslator();
const dateHelper = iframeDataBridge.getDateHelper();
const enumAppointment = iframeDataBridge.enumAppointment;
const user = iframeDataBridge.getCurrentUser();

const isFullscreen = ref(false);
const widgetRootRef = ref(null);
const kpi = ref({
	color: 'primary',
	width: 12,
});

const props = defineProps({
	title: String,
	selectedDate: Date,
	params: Object,
	guid: String,
});

const isLoading = ref(false);

// #endregion

// #region LIFECYCLE

onMounted(() => {
	init();
});

onBeforeUnmount(() => {});

// #endregion

// #region METHODS

function init() {}

function toggleFullscreen() {
	isFullscreen.value = !isFullscreen.value;

	eventBus.emit('widget-fullscreened', {
		widget: 'widget-kpi',
		fullScreened: isFullscreen.value,
	});
}

defineExpose({
	toggleFullscreen,
	isFullscreen,
});

// #endregion
</script>
